module.exports = __webpack_public_path__ + "img/symbol_1.1b70f4da.png";